import { _ as _define_property } from "@swc/helpers/_/_define_property";
import Decimal from 'decimal.js';
export class AvailableCreditModel {
    static sumCredits(credits) {
        return credits.filter((c)=>!c.isPaused()).reduce((a, b)=>a.plus(b.totalAmount()), new Decimal(0)).abs();
    }
    toJSON() {
        return this.dto;
    }
    id() {
        return this.dto.id;
    }
    name() {
        return this.dto.name;
    }
    isPaused() {
        return this.dto.isPaused;
    }
    totalAmount() {
        return this.totalAmountDecimal;
    }
    constructor(dto){
        _define_property(this, "dto", void 0);
        _define_property(this, "totalAmountDecimal", void 0);
        this.dto = dto;
        this.totalAmountDecimal = new Decimal(dto.totalAmount).div(100).toDP(2);
    }
}
